import { types } from 'mobx-state-tree';
import OptionModel from "./optionModel";

const OptionsStore = types.model('OptionsStore', {
    data: types.array(OptionModel)
}).actions(self => ({
    add(item) {
        self.data.push({ ...item });
    }
})).views(self => ({
    getByGuid(id) {
        return self.data.find(item => item.guidStr === id);
    }
}));

export default OptionsStore;
